/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import Media from 'react-media';
import {
    object, shape, string,
} from 'prop-types';

const BottomBanner = ({
    classes, bottomBanner,
}) => {
    if (!bottomBanner) {
        return null;
    }
    return (
        <Grid container className={classes.container}>
            <Media query="(max-width: 599px)">
                {(matches) => (
                    matches ? (
                        bottomBanner?.banners.map((data) => (

                            <Link className={classes.bottomBanner} to={data.link?.href}>
                                <img src={data.mobile_image?.url} alt={data.mobile_image?.title} />
                            </Link>
                        ))
                    ) : (

                            bottomBanner?.banners.map((data) => (
                                <Grid item xs={12}>
                                    <Link className={classes.bottomBanner} to={data.link?.href}>
                                        <img src={data.desktop_image?.url} alt={data.desktop_image?.title} />
                                    </Link>
                                </Grid>
                            ))

                    )
                )}
            </Media>
        </Grid>
    );
};

BottomBanner.propTypes = {
    classes: object.isRequired,
    bottomBanner: shape({
        image: shape({
            url: string.isRequired,
            title: string.isRequired,
        }).isRequired,
        link: shape({
            href: string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default BottomBanner;
